import { fetchPlayers } from '../../../entities/player.js';

export const scope = 'DL_PICTURE';

export function fetchPlayersForDlIfNeeded(payload) {
    return (dispatch, getState) => {
        const info = getState().app.tools.dlpicture;

        if (!info.loading)
            dispatch(fetchPlayers(payload, scope, () => null));
    };
}



// WEBPACK FOOTER //
// ./src/actions/app/tools/dlpicture/index.js